import type { AppRouter } from "@runcheetah/api/router";
import type { inferRouterOutputs } from "@trpc/server";

/** Inferred from the `user.me` tRPC output schema. */
export type User = inferRouterOutputs<AppRouter>["user"]["me"];

export function getUserDisplayName(user: User): string {
  return user.name.trim() || user.email.split("@")[0] || user.email;
}

/**
 * Derive display initials from a user's name or email.
 *
 * - If `name` is provided, takes the first letter of each word (max 2).
 * - Otherwise falls back to the first character of the email.
 */
export function getUserInitials(user: User): string {
  const displayName = getUserDisplayName(user);
  if (displayName !== user.email) {
    return displayName
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  }

  return user.email[0]?.toUpperCase() ?? "?";
}
